let numbers = [
  "1.00₺",
  "2.00₺",
  "3.00₺",
  "4.00₺",
  "5.00₺",
  "6.00₺",
  "7.00₺",
  "8.00₺",
];

export default {
  headers: [
    "COMPANY",
    "Z-REPORT",
    "CASH",
    "CREDIT CARD",
    "FOOD CARD",
    "FOREIGN CURRENCY",
    "MOBILE PAYMENT",
    "COST",
    "DIFFERENCE",
  ],
  items: [
    { id: 0, th: "TEST 1", td: numbers },
    { id: 1, th: "TEST 2", td: numbers },
    { id: 2, th: "TEST 3", td: numbers },
    { id: 3, th: "TEST 4", td: numbers },
    { id: 4, th: "TEST 5", td: numbers },
    { id: 5, th: "TEST 6", td: numbers },
    { id: 6, th: "TEST 7", td: numbers },
    { id: 7, th: "TEST 8", td: numbers },
    { id: 8, th: "TEST 9", td: numbers },
    { id: 9, th: "TEST 10", td: numbers },
    { id: 10, th: "TEST 11", td: numbers },
    { id: 11, th: "TEST 12", td: numbers },
    { id: 12, th: "TEST 13", td: numbers },
  ],
};
